import React from 'react';
import { RoleLayout } from './roles/RoleShell';

const Dashboard = () => {
  return (
    <RoleLayout
      title="Resumen general"
      subtitle="Este espacio será el resumen diario del sistema Palmarama: actividad de reservas, invitaciones y entradas."
      roleLabel="Vista general"
    >
      <div style={{ fontSize: 14, color: 'var(--muted, #9ca3af)' }}>
        Por ahora, solo mostramos un mensaje de bienvenida. Más adelante aquí podrás ver
        métricas y gráficos del funcionamiento diario del boliche.
      </div>
    </RoleLayout>
  );
};

export default Dashboard;
